<template>
<div>
    {{time_regressivo}}
</div>
</template>

<script>

  export default {

    props: {
      timer: null,
    },

    data(){
      return{
        time_regressivo: null,
      }
    },

    mounted(){
      this.time_regressivo = this.converte_timestamp_tempo( this.timer )
    },

    methods: {

    },

  }

</script>


// WEBPACK FOOTER //
// src/components/cc_geral/cc_contagem_regressiva.vue